var _a;
import * as tslib_1 from "tslib";
import without from 'lodash/without';
import findIndex from 'lodash.findindex';
import { STREAM__SET_PARAM, STREAM__FETCH_FAILURE, STREAM__DELETE_ITEMS, STREAM__REPLACE_ITEM, STREAM__MOVE_ITEM, STREAM__INSERT_ITEMS, } from './actions';
export var handleInitAction = function (streamState, action) {
    var _a = action.streamParams, streamParams = _a === void 0 ? {} : _a, streamType = action.streamType, groupId = action.groupId, itemsPerFetch = action.itemsPerFetch, _b = action.items, items = _b === void 0 ? [] : _b, total = action.total, _c = action.hasMore, hasMore = _c === void 0 ? false : _c, _d = action.hasLess, hasLess = _d === void 0 ? false : _d;
    return tslib_1.__assign({}, streamState, { streamParams: streamParams,
        streamType: streamType,
        groupId: groupId,
        itemsPerFetch: itemsPerFetch,
        items: items,
        total: total,
        hasMore: hasMore,
        hasLess: hasLess });
};
export var handleFetchAction = function (streamState) { return (tslib_1.__assign({}, streamState, { isFetching: true, errorMsg: undefined })); };
export var handleFetchSuccessAction = function (streamState, action) { return (tslib_1.__assign({}, streamState, { isFetching: false, items: (streamState.items || []).concat(action.items), total: action.total !== undefined ? action.total : streamState.total, hasMore: !action.items || !action.items.length ? false : action.hasMore })); };
export var handleFetchPreviousSuccessAction = function (streamState, _a) {
    var _b = _a.payload, items = _b.items, _c = _b.dedupeFunction, dedupeFunction = _c === void 0 ? function () { return true; } : _c, hasLess = _b.hasLess;
    var dedupedItems = items.filter(function (item) {
        return dedupeFunction(item, streamState.items);
    });
    if (!dedupedItems.length) {
        return streamState;
    }
    return tslib_1.__assign({}, streamState, { isFetching: false, items: dedupedItems.concat(streamState.items), hasLess: hasLess });
};
export var handleFetchFailureAction = function (streamState, action) { return (tslib_1.__assign({}, streamState, { isFetching: false, errorMsg: action.errorMsg })); };
export var handleDeleteItemsAction = function (streamState, action) {
    var updatedItems = without.apply(void 0, [streamState.items || []].concat(action.items));
    var removedCount = (streamState.items || []).length - updatedItems.length;
    var updatedTotal = (streamState.total || 0) - removedCount;
    return tslib_1.__assign({}, streamState, { items: updatedItems, total: updatedTotal > 0 ? updatedTotal : 0 });
};
export var handleMoveItemAction = function (streamState, action) {
    var items = streamState.items;
    var position = action.position, item = action.item;
    var updatedItems = items.slice();
    updatedItems.splice(updatedItems.indexOf(item), 1);
    updatedItems.splice(position, 0, item);
    return tslib_1.__assign({}, streamState, { items: updatedItems });
};
export var handleReplaceItemAction = function (streamState, action) {
    var itemIndex = findIndex(streamState.items || [], action.predicate);
    if (itemIndex === -1) {
        return streamState;
    }
    var newItems = streamState.items.slice();
    newItems[itemIndex] = action.newItem;
    return tslib_1.__assign({}, streamState, { items: newItems });
};
export var handleInsertItemsAction = function (streamState, action) {
    var sorted = action.newItems.slice();
    sorted.sort(function (a, b) {
        if (a.offset === b.offset) {
            return 0;
        }
        return a.offset > b.offset ? 1 : -1;
    });
    var newItems = streamState.items.slice();
    var inserted = 0;
    for (var _i = 0, sorted_1 = sorted; _i < sorted_1.length; _i++) {
        var elem = sorted_1[_i];
        if (action.deduplicate && newItems.includes(elem.item)) {
            continue;
        }
        inserted++;
        var offset = Math.max(elem.offset, 0);
        if (offset >= newItems.length) {
            newItems.push(elem.item);
        }
        else {
            newItems.splice(offset, 0, elem.item);
        }
    }
    return tslib_1.__assign({}, streamState, { total: (streamState.total || 0) + inserted, items: newItems });
};
export var handleSetParam = function (streamState, action) {
    var _a;
    return (tslib_1.__assign({}, streamState, { streamParams: tslib_1.__assign({}, streamState.streamParams, (_a = {}, _a[action.paramType] = action.paramValue, _a)) }));
};
// installed to reducer of every stream type as they are
export var commonActionHandlers = (_a = {},
    _a[STREAM__FETCH_FAILURE] = function (streamState, action) { return handleFetchFailureAction(streamState, action); },
    _a[STREAM__MOVE_ITEM] = function (streamState, action) { return handleMoveItemAction(streamState, action); },
    _a[STREAM__DELETE_ITEMS] = function (streamState, action) { return handleDeleteItemsAction(streamState, action); },
    _a[STREAM__REPLACE_ITEM] = function (streamState, action) { return handleReplaceItemAction(streamState, action); },
    _a[STREAM__SET_PARAM] = function (streamState, action) { return handleSetParam(streamState, action); },
    _a[STREAM__INSERT_ITEMS] = function (streamState, action) { return handleInsertItemsAction(streamState, action); },
    _a);
//# sourceMappingURL=actionHandlers.js.map